import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  getAnnotationToolAdminProjectsPath,
  useAppDispatch,
  useAppSelector,
} from '@verantos-dev/core-annotation-tool';

import { useCreateWorkflowIdMutation } from './api/createProjectApiSlice';
import { useSyncAgentConcepts } from './hooks/useSyncAgentConcepts';
import { clearAllWizardStates, setWorkflowId } from './state/createProjectSlice';
import { selectIsAgentStepEnabled } from './state/selector';

interface UseCreateProjectWizardScreenResult {
  requiredFieldsFilled: boolean;
  setRequiredFieldsFilled: (requiredFieldsFilled: boolean) => void;
  handleCancelProjectCreation: () => void;
}

export const useCreateProjectWizardScreen = (): UseCreateProjectWizardScreenResult => {
  const dispatch = useAppDispatch();
  // TODO: cleanup with cp_annotation_createproject_agent ff
  // Step 2 edits happen while step 5 is unmounted, so the screen keeps the builder's
  // concepts in step. Reads the flag snapshot without writing it, and does nothing
  // with the flag off.
  useSyncAgentConcepts(useAppSelector(selectIsAgentStepEnabled) === true);
  const [requiredFieldsFilled, setRequiredFieldsFilled] = useState<boolean>(false);
  const [createWorkflowId, { data: workflowIdData, isLoading: isWorkflowIdLoading }] =
    useCreateWorkflowIdMutation();

  useEffect(() => {
    void createWorkflowId();
  }, [createWorkflowId]);

  useEffect(() => {
    if (workflowIdData?.data && !isWorkflowIdLoading) {
      dispatch(setWorkflowId(workflowIdData.data));
    }
  }, [dispatch, workflowIdData, isWorkflowIdLoading]);

  const navigate = useNavigate();
  const handleCancelProjectCreation = () => {
    dispatch(clearAllWizardStates());
    navigate(getAnnotationToolAdminProjectsPath());
  };

  return {
    requiredFieldsFilled,
    setRequiredFieldsFilled,
    handleCancelProjectCreation,
  };
};
